import { useState, useCallback } from 'react';
import { MetaplanItemResponseDto } from '@tiendanube/common';
import {
  useGetMetaplansQuery,
  GetMetaplansParams,
} from '../../subscriptionsApi';

interface UseMetaplansListReturn {
  metaplans: MetaplanItemResponseDto[];
  total: number;
  isLoading: boolean;
  isError: boolean;
  isEmpty: boolean;
  isSuccess: boolean;
  params: GetMetaplansParams;
  refetch: () => void;
  setSearchQuery: (q: string) => void;
  setPage: (page: number) => void;
}

const DEFAULT_PARAMS: GetMetaplansParams = {
  page: 1,
  limit: 20,
  q: '',
};

export const useMetaplansList = (): UseMetaplansListReturn => {
  const [params, setParams] = useState<GetMetaplansParams>(DEFAULT_PARAMS);

  const { data, isLoading, isFetching, isError, isSuccess, refetch } =
    useGetMetaplansQuery(params);

  const metaplans = data?.items ?? [];
  const total = data?.items?.length ?? 0;
  const loading = isLoading || isFetching;
  const isEmpty = isSuccess && metaplans.length === 0;

  const setSearchQuery = useCallback((q: string) => {
    setParams((prev) => ({ ...prev, q, page: 1 }));
  }, []);

  const setPage = useCallback((page: number) => {
    setParams((prev) => ({ ...prev, page }));
  }, []);

  return {
    metaplans,
    total,
    isLoading: loading,
    isError,
    isEmpty,
    isSuccess,
    params,
    refetch,
    setSearchQuery,
    setPage,
  };
};
